import { gql } from "@apollo/client";

export const orgForMigratedAssets = gql`
    query orgForMigratedAssets {
        orgForMigratedAssets {
            assets
            organizationName
        }
    }
`;
